import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import { Typography } from '@material-ui/core';
import FormGroup from '@material-ui/core/FormGroup';

import { getDialogLoading, getLoading, getUser } from '../../selectors';
import Button from '../core/components/Button';
import DialogView from '../core/components/DialogView';
import TextBoxComponent from '../core/components/TextBoxComponent';
import CheckBoxComponent from '../core/components/CheckBoxComponent';
import { FeatureFlags } from '../../services/functions/FeatureFlag';
import * as Functions from '../../services/functions/Functions';

import '../../css/authentication/LoginDialog.scss';
import { DIALOG_CONSTANTS } from '../core/DialogConstants';
import { DIALOG_NAMES } from '../../services/api/CloudEvents/constants';
import withCloudEventBaseParams from '../../events/HOCs/withCloudEventBaseParams';

const initialState = {
  email: '',
  password: '',
  rememberUser: false,
  error: '',
};
const loginFields = [
  {
    autoFocus: true,
    type: 'TextBox',
    title: 'E-mail',
    fieldKey: 'email',
    fieldType: '',
  },
  {
    autoFocus: false,
    type: 'TextBox',
    title: 'Password',
    fieldKey: 'password',
    fieldType: 'password',
  },
  {
    autoFocus: false,
    type: 'CheckBox',
    fieldKey: 'checkBoxUser',
    checkBoxes: [
      {
        title: 'Keep me signed in',
        fieldKey: 'rememberUser',
      },
    ],
  },
];

// TODO: Reset password
class LoginDialog extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  getProps = () => {
    const {
      handleClickOptions,
      translation,
      cartIconWasPressed,
    } = this.props;

    const onClickCreateAnAccount = () => {
      handleClickOptions(translation('HeaderComponent.createAccount'));
    };
    return (
      {
        dialogTitle: {
          dialogTitleStyle: 'loginDialog-dialogTitleStyle',
          dialogTitleStyleVariant: 'h2',
          dialogTitleText: '',
          dialogTitleSubheader: '',
          dialogTitleSubheaderImageAlt: translation('CoreView.header.logoAlt'),
          subHeaderImageContainerStyle: 'loginDialog-subHeaderImageContainerStyle',
          subHeaderImageStyle: 'loginDialog-subHeaderImageStyle',
        },
        dialogBodyContainerStyle: 'loginDialog-dialogBodyContainerStyle',
        dialogContentStyle: 'loginDialog-dialogContentStyle',
        dialogContent: (
          <div>
            {
              FeatureFlags.LoginDialog.useCustomMessage
              && (
                <Typography>
                  {translation('LoginDialog.customMessage')}
                </Typography>
              )
            }
            <form className="loginDialog-formContainer" noValidate autoComplete="off">
              {
                loginFields.map((field) => {
                  const FieldType = this.getComponentTypeTag(field.type);

                  if (field.type !== 'CheckBox') {
                    return (
                      <FieldType
                        key={field.fieldKey}
                        {...field}
                        field={field}
                        selectedValue={this.state[`${field.fieldKey}`]}
                        handleChange={
                          (fieldItem, selectedItems) => this.handleChange(fieldItem, selectedItems)
                        }
                        fieldAutoFocus={field.autoFocus}
                      />
                    );
                  }

                  return (
                    <FormGroup
                      key={field.fieldKey}
                      className="loginDialog-formGroupStyle"
                    >
                      <div className="loginDialog-promptContainer">
                        <Typography>
                          {translation('LoginDialog.dialogContent2.forgotPassword')}
                        </Typography>
                        &nbsp;
                        <Typography>
                          <a
                            id="reset"
                            href="#"
                            onClick={() => this.handleClickReset()}
                            className="loginDialog-dialogContent2Link"
                          >
                            {translation('LoginDialog.dialogContent2.reset')}
                          </a>
                        </Typography>
                      </div>
                      {
                        field.checkBoxes.map(checkBox => (
                          <FieldType
                            id="keepSignedIn"
                            key={checkBox.fieldKey}
                            field={checkBox}
                            selectedValue={this.state[`${checkBox.fieldKey}`]}
                            handleChange={
                              (e, checkBoxField) => this.handleChangeCheckBox(e, checkBoxField)
                            }
                          />
                        ))
                      }
                    </FormGroup>
                  );
                })
              }
            </form>
          </div>
        ),
        dialogContent2: (
          <Fragment>
            <div className="loginDialog-dialogContent2">
              <div className="loginDialog-promptContainer">
                <Typography variant="body1">
                  {translation('HeaderComponent.nonMember')}
                </Typography>
                &nbsp;
                <Typography variant="body1">
                  <a
                    href="#"
                    onClick={onClickCreateAnAccount}
                    className="loginDialog-dialogContent2Link"
                  >
                    {translation('HeaderComponent.createAccount')}
                  </a>
                </Typography>
              </div>
            </div>
            {
              (cartIconWasPressed && FeatureFlags.enableGuestCheckout)
              && (
                <div className="loginDialog-guestUserContainer">
                  <div className="loginDialog-orSeparator">
                    <div className="loginDialog-separatorLine" />
                    <Typography variant="body1">
                      {translation('or')}
                    </Typography>
                    <div className="loginDialog-separatorLine" />
                  </div>
                  <Button
                    id="guestCheckout"
                    type="primary"
                    onClick={() => this.handleGuestCheckout()}
                    fullWidth
                    text={translation('LoginDialog.dialogActions.guestCheckout')}
                  />
                </div>
            )
          }
          </Fragment>

        ),
        dialogActions: {
          actionButtons: (
            <Button
              id="signIn"
              type="primary"
              onClick={this.handleLogin}
              disabled={this.disableButton()}
              fullWidth
              text={translation('LoginDialog.dialogActions.signIn')}
            />
          ),
        },
      });
  };

  getComponentTypeTag = (fieldType) => {
    switch (fieldType) {
      case 'TextBox':
        return TextBoxComponent;
      case 'CheckBox':
        return CheckBoxComponent;
      default:
        return TextBoxComponent;
    }
  };

  handleChangeCheckBox = (event, field) => {
    this.setState({
      [field.fieldKey]: event.target.checked,
    });
    this.props.actions.setRememberUser(event.target.checked);
  }

  handleChange = (field, selectedItem) => {
    this.setState({
      [field.fieldKey]: selectedItem,
    });
  };

  handleClickReset = () => {
    const dialogObj = {
      dialog: DIALOG_CONSTANTS.LOGIN,
      openResetPasswordDialog: true,
      eventSource: 'clickResetFromLogin',
    };
    this.setState(initialState);
    this.props.handleClose(dialogObj);
  };

  handleGuestCheckout = () => {
    const dialogObj = {
      dialog: DIALOG_CONSTANTS.LOGIN,
      openGuestSignInDialog: true,
      eventSource: 'clickGuestCheckout',
    };
    this.setState(initialState);
    this.props.handleClose(dialogObj);
  }

  handleLogin = async () => {
    const {
      actions,
      rememberUser,
      currentOrder,
      sendUserToCheckout,
    } = this.props;
    const { email, password } = this.state;
    const user = { email, password };

    try {
      const response = await actions.loginUser(user);

      if (response.error) {
        // TO-DO: Improve error result on API so we don't have to rely on the error message
        if (response.error.message === 'User is not verified') {
          const dialogObj = {
            dialog: DIALOG_CONSTANTS.LOGIN,
            userEmail: email,
            openVerifyDialog: true,
            eventSource: 'unverifiedUserOnLogin',
          };
          this.setState(initialState);
          this.props.handleClose(dialogObj);
        }
      } else {
        if (rememberUser) {
          localStorage.setItem('user', JSON.stringify(response.loggedInUser));
        }

        // Check if the user has something in the cart
        if (currentOrder.items) {
          await actions.createOrder(response.loggedInUser, currentOrder, currentOrder.price);
        } else {
          const getOrdersResponse = await actions.getAllResources(response.loggedInUser.token, ['users', response.loggedInUser.id, 'orders']);

          // If the user has an existing order, find the new order and set it in currentOrder
          if (!getOrdersResponse.error && getOrdersResponse.response.length > 0) {
            const order = Functions.getNewestOrder(getOrdersResponse.response);
            if (order.orderStatus === 'NEW') {
              actions.getItemsAndCreateOrder(response.loggedInUser, order, ['users', response.loggedInUser.id, 'orders', order.id, 'items']);
            }
          }
        }

        sendUserToCheckout();
        this.handleClose({ dialog: DIALOG_CONSTANTS.LOGIN, eventSource: 'loginSuccess' });
      }
    } catch (error) {
      console.log('API call error', error);
    }
  };

  handleClose = (closeDialogOptions = { dialog: DIALOG_CONSTANTS.LOGIN }) => {
    this.setState(initialState);
    this.props.handleClose(closeDialogOptions);
  }

  disableButton = () => {
    const { dialogLoading, loading } = this.props;
    const { email, password } = this.state;
    return isEmpty(email && password) || dialogLoading !== 0 || loading !== 0;
  };

  render() {
    const { open } = this.props;
    const stepPros = this.getProps();
    const {
      dialogTitle,
      dialogContent,
      dialogContent2,
      dialogActions,
      dialogBodyContainerStyle,
      dialogContentStyle,
    } = stepPros;

    return (
      <DialogView
        dialogName={DIALOG_NAMES.LOGIN}
        open={open}
        titleAlignClose={false}
        handleClose={() => this.handleClose()}
        disableEscapeKeyDown={false}
        dialogTitleStyle={dialogTitle.dialogTitleStyle}
        dialogTitleStyleVariant={dialogTitle.dialogTitleStyleVariant}
        subHeaderImageContainerStyle={dialogTitle.subHeaderImageContainerStyle}
        subHeaderImageStyle={dialogTitle.subHeaderImageStyle}
        dialogBodyContainerStyle={dialogBodyContainerStyle}
        dialogContentStyle={dialogContentStyle}
        titleHasCloseBtn
        dialogTitleText={dialogTitle.dialogTitleText}
        dialogTitleSubheaderImage={dialogTitle.dialogTitleSubheaderImage}
        dialogTitleSubheaderImageAlt={dialogTitle.dialogTitleSubheaderImageAlt}
        hasDialogContent
        hasDialogContent2
        hasDialogErrorContent={false}
        renderDialogContent={() => dialogContent}
        renderDialogContent2={() => dialogContent2}
        hasDialogActions
        actionBtnStyle="loginDialog-actionBtnStyle"
        renderActionBtn={() => dialogActions.actionButtons}
        dialogCloseIconColor="var(--back-button-color)"
      />
    );
  }
}

LoginDialog.propTypes = {
  cartIconWasPressed: PropTypes.bool.isRequired,
  handleClickOptions: PropTypes.func.isRequired,
  dialogLoading: PropTypes.number.isRequired,
  loading: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
  rememberUser: PropTypes.bool.isRequired,
  translation: PropTypes.func.isRequired,
  currentOrder: PropTypes.objectOf(PropTypes.any).isRequired,
  sendUserToCheckout: PropTypes.func.isRequired,
  user: PropTypes.objectOf(PropTypes.any),
};

LoginDialog.defaultProps = {
  user: null,
};

const mapStateToProps = state => ({
  dialogLoading: getDialogLoading(state),
  loading: getLoading(state),
  user: getUser(state).user,
});

export default connect(mapStateToProps)(withRouter(withCloudEventBaseParams(LoginDialog)));

